module.exports = __webpack_public_path__ + "img/message.ff4cea01.svg";